<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickOk"
                >
                    Ok
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="margin-top: 15px"
        >
            <v-text-field
                label="Search"
                prepend-icon="mdi-magnify"
                v-model="full_text"
                v-on:input="update"
                autocomplete="off"
            >
            </v-text-field>

            <v-checkbox
                v-model="show_technical_details"
                label="Show Technical Details"
                v-on:change="doUpdate"
                style="margin-top: -15px"
            />
            
            <v-data-table
                v-if="results != null"
                :headers="headers"
                :items="results"
                :items-per-page="1000"
                class="elevation-1"
                :hide-default-footer="true"
                disable-sort
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"
            >
                <template v-slot:item.time_date="{ item }">
                    {{$rc.pretty(item.time,'date')}}
                </template>

                <template v-slot:item.time_time="{ item }">
                    {{$rc.pretty(item.time,'time')}}
                </template>

                <template v-slot:item.text="{ item }">
                    <div
                        style="font-family: monospace"
                        v-html="$rc.wrapHTML(item.text,false)"
                    >
                    </div>
                </template>
            
            </v-data-table>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

const _ = require('lodash');
export default {

    props: {
        title: {
            type: String,
            default: function() { return 'Technical Details'; }
        },
    },

    data() {
        return {
            dialog: false,

            full_text: null,
            show_technical_details: false,
            results: [],

            search: {},

            headers: [
                { text: 'Date', value: 'time_date'},
                { text: 'Time', value: 'time_time'},
                { text: 'Text', value: 'text'},
            ],
        }
    },

    methods: {

        showDialog(search)
        {
            this.search = _.cloneDeep(search);
            this.full_text = null;
            this.results = [];
            this.show_technical_details = false;

            this.doUpdate();
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {
            let params = _.cloneDeep(this.search);

            params.full_text = this.full_text;
            params.is_technical = this.show_technical_details ? null : false;

            this.$rc.rest(
                'LIST: /api/v1/logs',

                params,
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to search technical details');
                },
            );
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            this.dialog = false;
            next(false);
            return;
        },

        onClickOk()
        {
            this.closeDialog();
        },

    },
}
</script>

<style lang="scss" scoped>
</style>